export const HOME = "/";
export const SIGN_UP = "/inscription";
export const SIGN_IN = "/connexion";
export const FORGOTTEN_PASSWORD = "/mot-de-passe-oublie";
export const NEW_PASSWORD = "/nouveau-mot-de-passe/:token";
export const CONFIRM = "/confirmation/:token";
export const SERIES = "/series";
export const SERIE = serieId => `/series/${serieId}`;
export const STATS  = "/stats";
export const STAT = statId => `/stats/${statId}`;
export const MY_ACCOUNT = "/mon-compte";
export const ID = ":id";